import React from "react";
import OptimizedAlbumImage from "../../optimized-image/OptimizedAlbumImage";
import "./gallery-page.scss";

export const Album = ({ photo, onClick, selected }) => {
    const handleAlbumClassname = () => {
        return selected === true
            ? "gallery-page__album gallery-page__album--selected"
            : "gallery-page__album";
    };
    return (
        <div
            className={handleAlbumClassname()}
            onClick={() => onClick(photo.year)}
        >
            <OptimizedAlbumImage src={photo.src} />
            <div className="gallery-page__album-info">
                <h3 className="gallery-page__album-year">
                    {"Tábor " + photo.year}
                </h3>
                <h3 className="gallery-page__album-title">{photo.title}</h3>
            </div>
        </div>
    );
};

export default Album;
